var exports = {
  "kL": "AttachmentFile.module__container___ZDBSa2",
  "G5": "AttachmentFile.module__deleteButton___ZDBSa2",
  "Dq": "AttachmentFile.module__attachmentContainer___ZDBSa2",
  "zc": "AttachmentFile.module__iconContainer___ZDBSa2",
  "el": "AttachmentFile.module__fileInfoContainer___ZDBSa2",
  "Md": "AttachmentFile.module__fileName___ZDBSa2",
  "m$": "AttachmentFile.module__fileNameTruncate___ZDBSa2",
  "i_": "AttachmentFile.module__fileExtension___ZDBSa2",
  "Ov": "AttachmentFile.module__fileSize___ZDBSa2",
  "l6": "AttachmentFile.module__downloadButton___ZDBSa2",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___ZDBSa2",
};

module.exports = exports;
